var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getRootLogger } from '@lucidlink/tscore';
import { useUserClient } from '@lucidlink/uicore';
import { broadcastMessage, useLucidSdk } from '#context';
import { CurrentProfileKeyFactory } from '#query-hooks';
export const useSsoLogin = ({ onError, onSuccess, } = {}) => {
    _react_refresh_temp_1();
    const { windowId } = useUserClient();
    const { lucidSdk } = useLucidSdk();
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async ({ loginEmail, ...params }) => {
            await lucidSdk.authenticationClient().ssoLogin(params);
        },
        onError: (e, { loginEmail: email }) => {
            if (typeof onError === 'function') {
                onError(e);
            }
            getRootLogger().error({ err: e, email }, 'Sso login failed');
        },
        onSuccess: async (_, { loginEmail: email }) => {
            await queryClient.refetchQueries({
                queryKey: CurrentProfileKeyFactory.exact(),
                exact: true,
            });
            broadcastMessage({ type: 'login', payload: { windowId } });
            getRootLogger().info({ email }, 'Sso login succeeded');
            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        },
    });
    return mutation;
};
_react_refresh_temp_1(useSsoLogin, "KnpCSD4e7jVzXlgdEDeHLyCEdU8=", false, () => [useUserClient, useLucidSdk, useQueryClient, useMutation]);
